import { message } from 'antd';

import { formatNumber } from './format';

/**
 * نمایش نتیجهٔ عملیات گروهی با گزارش موفق/ناموفق.
 *
 * @param {{
 *   succeeded?: string[],
 *   failed?: Array<{id?: string, reason?: string}>,
 *   succeeded_count?: number,
 *   failed_count?: number,
 * }} [result]
 * @param {{ successLabel?: string, emptyLabel?: string }} [opts]
 */
export function reportBulkResult(result, opts = {}) {
  const successLabel = opts.successLabel || 'عملیات گروهی انجام شد.';
  const emptyLabel = opts.emptyLabel || 'هیچ موردی پردازش نشد.';
  const succeededCount = Number(
    result?.succeeded_count ?? (Array.isArray(result?.succeeded) ? result.succeeded.length : 0),
  );
  const failed = Array.isArray(result?.failed) ? result.failed : [];
  const failedCount = Number(result?.failed_count ?? failed.length);

  if (succeededCount <= 0 && failedCount <= 0) {
    message.warning(emptyLabel);
    return;
  }

  if (failedCount <= 0) {
    message.success(`${successLabel} (${formatNumber(succeededCount)} مورد)`);
    return;
  }

  const firstReason = failed.find((item) => item?.reason)?.reason;
  const detail = firstReason ? ` نمونه خطا: ${firstReason}` : '';
  message.warning(
    `${formatNumber(succeededCount)} موفق، ${formatNumber(failedCount)} ناموفق.${detail}`,
  );
}

/**
 * دانلود پاسخ blob به‌عنوان فایل.
 * @param {Blob} blob
 * @param {string} filename
 */
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
}
